class CartNotification extends HTMLElement {
  constructor() {
    super();

    var self = this;

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-notification__close').forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeDrawer();
      })
    });
  }

  open() {
    this.notification.classList.add('active');
  }

  closeDrawer() {
    this.notification.classList.remove('active');
  }

  renderContents(parsedState) {
    var self = this;
    this.getSectionsToRender().forEach((section => {
      document.querySelector('#' + section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.querySelectorAll('.cart-notification__close').forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeDrawer();
      })
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification',
        selector: '#cart-notification'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
